import { render, staticRenderFns } from "./InsuranceClients.vue?vue&type=template&id=9c4bf216&"
import script from "./InsuranceClients.vue?vue&type=script&lang=js&"
export * from "./InsuranceClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports